// @flow

import { combineReducers } from "redux";
import managerDetails, { initialState as managerDetailsInitialState } from "./manager-details";
import compliance, { initialState as managerComplianceInitialState } from "./compliance";

export const initialState = {
  managerDetails: managerDetailsInitialState,
  compliance: managerComplianceInitialState,
};

export default combineReducers({
  managerDetails,
  compliance,
});
